<div style="display: block;height:auto;width:900px;" id="containerCompleto">
  <div id="titulo">
    <h2>Colaboradores AXA</h2>
    <h2 id="btnCerrar" mat-flat-button style="margin-right: 20px;" (click)="onClose()" >X</h2>
  </div>
  <div id="tablaContainer">
    <table mat-table class="tabla-art" [dataSource]="dataSource" style="min-width: auto; letter-spacing: 0;">
      <ng-container matColumnDef="cp">
        <th mat-header-cell *matHeaderCellDef>CP</th>
        <td mat-cell *matCellDef="let element">{{element.cp}}</td>
      </ng-container>
      <ng-container matColumnDef="poblacion">
        <th mat-header-cell *matHeaderCellDef>Población</th>
        <td mat-cell *matCellDef="let element">{{element.poblacion}}</td>
      </ng-container>
      <ng-container matColumnDef="provincia">
        <th mat-header-cell *matHeaderCellDef>Provincia</th>
        <td mat-cell *matCellDef="let element">{{element.provincia}}</td>
      </ng-container>
      <ng-container matColumnDef="taller">
        <th mat-header-cell *matHeaderCellDef>Taller</th>
        <td mat-cell *matCellDef="let element">{{element.taller}} {{element.nombre}}</td>
      </ng-container>
      <ng-container matColumnDef="direccion">
        <th mat-header-cell *matHeaderCellDef>Dirección</th>
        <td mat-cell *matCellDef="let element">{{element.direccion}}</td>
      </ng-container>
      <ng-container matColumnDef="telefono">
        <th mat-header-cell *matHeaderCellDef>Teléfono</th>
        <td mat-cell *matCellDef="let element">{{element.telefono}}</td>
      </ng-container>
      <ng-container matColumnDef="horariolv">
        <th mat-header-cell *matHeaderCellDef>H.LV</th>
        <td mat-cell *matCellDef="let element">{{element.horariolv}}</td>
      </ng-container>
      <ng-container matColumnDef="horariosb">
        <th mat-header-cell *matHeaderCellDef>H.SB</th>
        <td mat-cell *matCellDef="let element">{{element.horariosb}}</td>
      </ng-container>
      <ng-container matColumnDef="horariomv">
        <th mat-header-cell *matHeaderCellDef>H.MV</th>
        <td mat-cell *matCellDef="let element">{{element.horariomv}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay" (dblclick)="cargarColaborador(row)"></tr>
    </table>
  </div>
  <mat-paginator class="paginador" [pageSizeOptions]="[10]" [length]="dataSource.data.length" [pageSize]="10" [showFirstLastButtons]="true" #paginator (page)="onPageChange($event)"></mat-paginator>
</div>
